import * as actionTypes from './actionTypes'
import * as components from './components'
import * as hooks from './hooks'
import * as types from './types'

console.log('Customers feature initialized!')

export { actionTypes, components, hooks, types }
